import { FormField, Select, type SelectOption } from "@design";
import { useId } from "react";
import { Hint } from "./Hint";

/**
 * A labelled Select for the model form. Unlike the form kit's SelectField the
 * accessible name is the field label (not the selected option), which keeps
 * the many selects on this form distinguishable.
 */
export function LabeledSelect({
  label,
  hint,
  value,
  options,
  onChange,
}: Readonly<{
  label: string;
  hint?: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
}>) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1">
      <FormField label={label} htmlFor={id}>
        <Select id={id} aria-label={label} value={value} options={options} onChange={onChange} />
      </FormField>
      {hint && <Hint>{hint}</Hint>}
    </div>
  );
}
